import { useSupplierBucketSetting as useSupplierBucketSettingBase } from '@bridebook/toolbox/src/gazetteer/hooks/use-supplier-bucket-setting';
import type { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { PremiumTiers } from '@bridebook/toolbox/src';
import { ISupplier_Type } from '@bridebook/models/source/models/Suppliers.types';

/**
 * Hook to get a bucket setting for a supplier, using the web app's market.
 * Wraps the toolbox useSupplierBucketSetting with useMarket().
 *
 * @param settingName The setting key to retrieve.
 * @param tier The supplier's premium tier.
 * @param type The supplier type.
 */
export function useSupplierBucketSetting<K extends keyof IBucket['settings']>(
  settingName: K,
  type: ISupplier_Type | undefined,
  tier: PremiumTiers | undefined = PremiumTiers.Unverified,
) {
  const market = useMarket();
  return useSupplierBucketSettingBase(settingName, type, market, tier);
}
